module.exports = "/_next/static/images/uzuna_menu_top-9617e85034ccb218f3ae1f3c191e4bc2.jpg";